import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getToken, getUnderWriting,isHappyPath, savePolicyHolderName, populateUnderWriting  } from './actions';
import StartForm from './StartForm';
import { updateTitle } from '../SectionTitle/actions';
import { showLoading, hideLoading } from '../LoadingComponent/actions';
import defaultData from '../data/index.json';
//import TestCases from '../data/testCases';



const mapStateToProps = (state) => {
    return {
        quoteStart: state.quoteStart
    }
}

const mapDispatchTopProps = (dispatch) => {
    return {
        getToken: () => dispatch(getToken()),
        getUnderWriting: (token, formValues) => dispatch(getUnderWriting(token, formValues)),
        updateTitle: (titleObject) => dispatch(updateTitle(titleObject)),
        showLoading: () => dispatch(showLoading()),
        savePolicyHolderName: (name)=>dispatch(savePolicyHolderName(name)),
        hideLoading: ()=> dispatch(hideLoading()),
        populateUnderWriting:(data)=>dispatch(populateUnderWriting(data)),
        isHappyPath: (value)=>dispatch(isHappyPath(value))
    }
}

class StartQuoteContainer extends React.Component {
    constructor(props){
        super(props);
        this.populateDataForDevelopment = this.populateDataForDevelopment.bind(this);
        //this.savePolicyHolderName = this.savePolicyHolderName.bind(this);
        this.setHappyPath = this.setHappyPath.bind(this);        
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        //this.props.hideLoading();
        this.props.updateTitle({
            title: '<h1>Let\'s get started!</h1>',
            subTitle: 'Quick quotes ahead.',
            image: '<i class="fa fa-location-arrow" aria-hidden="true"></i>'
        });
        console.log(this.props);
        if (this.props.quoteStart.token === undefined) {
            this.props.getToken();
        }
        //else if(quoteStart.)
    }

    setHappyPath(e){
        const {happyPath} = this.props.quoteStart;
        if(happyPath === false){
            this.props.isHappyPath(true);
        }
        else{
            this.props.isHappyPath(false);
        }
        
    }

    populateDataForDevelopment(){
        this.props.populateUnderWriting(defaultData);
        const {subjects} = defaultData.body.completeQuote;

        const policyHolder = subjects.find((element)=>{
            console.log(element);
            return element.relationToPolicyHolder.code === "PP";
        });

        this.props.savePolicyHolderName(policyHolder.givenName);

        const {history} = this.props;
        history.push('/confirm');
    }

    submit = values => {    
        if(this.props.quoteStart.underWriting === undefined){
        const resolveAccessToken = new Promise((resolve, reject) => {
            resolve(this.props.quoteStart.token);
        });
        this.props.showLoading();
        const updatedValues = this.prepareFormDataForSubmission(values);
        const {GivenName} = values;
        const { access_token } = this.props.quoteStart.token;
        
        resolveAccessToken.then(token =>{
            console.log(token);
        });
        //write something to validate data before making a request
        const underWritingData = this.props.getUnderWriting(access_token, updatedValues);
        //this.props.loadStartQuote(updatedValues);

        this.props.savePolicyHolderName(GivenName);
        console.log(this.props);



        const quoteStartedPromise = new Promise((resolve, reject)=>{                 
             resolve(underWritingData);
             //reject(underWritingData, 'test');
        });

        console.log(this.props.quoteStart.underWriting);
            
            quoteStartedPromise.then((response, err)=>{
                console.log(response);
                console.log(underWritingData);
                if(!response.header){
                    throw Error('an error has occurred here');
                }
                this.props.history.push('/confirm');
            }).catch((err)=>{
                
                console.log(err);
                alert('an error has occurred');
            });
        }
        else{
            this.props.history.push('/confirm');
        }
        
    }

    prepareFormDataForSubmission(values){
        const { GivenName } = values;
        const { Surname } = values;
        const { DOB } = values;
        const addressData = {
            Street1: values.Street1,
            StateCode: values.StateCode,
            Zip: values.Zip,
            City: values.City,
            AddressType: 'Current'
        };
    
        const formData = {
            "Driver": {
                GivenName,
                Surname,
                DOB: this.prepareDateForSubmission(DOB)
            },
            Addresses: []
        };

        formData.Addresses.push(addressData);
        return formData;
    }

    prepareDateForSubmission = (date) => {
        const firstIndex = date.indexOf('/');
        const lstIndex = date.lastIndexOf('/');        
        const month = date.substring(0,firstIndex);
        const year = date.substring(lstIndex + 1);
        const day = date.substring(firstIndex+1, lstIndex);
        console.log(`month ${month}`);
        console.log(`year ${year}`);
        console.log(`day ${day}`);
        console.log(date)
        return `${year}${day}${month}`;
    }

    populateForm(){
        console.log(this.props);
    }

    render() {
        
       const DevelopmentButton = ()=>{
           return (
               <button onClick={this.populateDataForDevelopment}>Development </button>
           );
       }

       const {happyPath} = this.props.quoteStart;
       console.log(this.props.quoteStart.token)
       let tokenRecieved = this.props.quoteStart.token!==(undefined || null)?true: false;

        return (
            <div>
                {/*{JSON.stringify(tokenRecieved)}*/}
                {process.env.NODE_ENV ==='development'? <DevelopmentButton />: null}
                <div className="form-group">
                <label>Do you want the fastlane?</label>
                    <div className="form-check">
                    <label htmlFor="fastlane">
                <input                     
                    id="fastlane"
                    onChange={this.setHappyPath}
                    type="checkbox"
                    checked={happyPath}
                    name="fastlane" 
                    />
                    {` Yes`}
                </label>
                    </div>
                </div>
                {/*
                <button className="btn btn-success" onClick={this.setHappyPath}>Fastlane</button>
                <br/>
                 */}
                <br/>
                <StartForm isTokenRecieved={tokenRecieved} onSubmit={this.submit} />
            </div>
        );
    }
}

const connectedContainer = connect(mapStateToProps, mapDispatchTopProps)(StartQuoteContainer)

export default withRouter(connectedContainer);


// WEBPACK FOOTER //
// ./src/StartQuote/StartQuoteContainer.js